import { add } from 'date-fns'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { FilterActions, InitialFilterState, useFiltersContext } from '@/context'
import useScheduledCommunicationsSection from '@/hooks/useDashboard/useScheduledCommunicationsSection'
import { ScheduledCommunicationStatus } from '@/types/ScheduledCommunication'

import { Card } from './Card'

const ScheduledCommunications = () => {
  const upcomingQuery = useScheduledCommunicationsSection()
  const upcomingData = upcomingQuery?.data?.agmDashboard
  const navigate = useNavigate()
  const [, FilterDispatch] = useFiltersContext()

  const handleScheduledCommunications = (scheduledCommunicationStatus: ScheduledCommunicationStatus) => {
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'scheduledCommunications',
        filters: {
          ...InitialFilterState['scheduledCommunicationsFilters'],
          scheduledCommunicationStatuses: [scheduledCommunicationStatus],
        },
      }),
    )
    navigate('/scheduledCommunications')
  }

  const handleScheduledCommunicationsWithDate = (scheduledCommunicationStatus: ScheduledCommunicationStatus) => {
    const sevenDays = add(new Date(), { days: 7 })
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'scheduledCommunications',
        filters: {
          ...InitialFilterState['scheduledCommunicationsFilters'],
          scheduledDatetime: {
            end: sevenDays,
          },
          scheduledCommunicationStatuses: [scheduledCommunicationStatus],
        },
      }),
    )
    navigate('/scheduledCommunications')
  }

  return (
    <>
      <h2 className="my-4 text-xl">Scheduled Communications</h2>
      <div className="grid grid-cols-4 grid-rows-1 place-items-stretch gap-3 md:gap-6">
        <Card
          label="Total pending approval"
          loading={upcomingQuery?.isLoading}
          onClick={() => handleScheduledCommunications(ScheduledCommunicationStatus.PendingApproval)}
          value={upcomingData?.totalPendingApprovalScheduledCommunications || 0}
        />
        <Card
          label="Pending approval (next 7 days)"
          loading={upcomingQuery?.isLoading}
          onClick={() => handleScheduledCommunicationsWithDate(ScheduledCommunicationStatus.PendingApproval)}
          subLabel={`${upcomingData?.totalPendingApprovalScheduledCommunicationsToday || 0} today`}
          value={upcomingData?.totalPendingApprovalScheduledCommunicationsNextWeek || 0}
        />
        <Card
          label="Total pending delivery"
          loading={upcomingQuery?.isLoading}
          onClick={() => handleScheduledCommunications(ScheduledCommunicationStatus.PendingDelivery)}
          value={upcomingData?.totalPendingDeliveryScheduledCommunications || 0}
        />
        <Card
          label="Pending delivery (next 7 days)"
          loading={upcomingQuery?.isLoading}
          onClick={() => handleScheduledCommunicationsWithDate(ScheduledCommunicationStatus.PendingDelivery)}
          subLabel={`${upcomingData?.totalPendingDeliveryScheduledCommunicationsToday || 0} today`}
          value={upcomingData?.totalPendingDeliveryScheduledCommunicationsNextWeek || 0}
        />
      </div>
    </>
  )
}

export default ScheduledCommunications
